import { useEffect, useState } from "react";
import React from 'react';
import { useLocation } from "react-router-dom";
import axios from "axios"
import AOS from "aos";
import { useRef } from "react";
import "aos/dist/aos.css";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { FaSearch } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import modalVideo from "../../assets/modal.mp4";
import HeaderWithAdd from "../../components/HeaderWithAd/HeaderWithAd";
import { motion } from "framer-motion";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import { useNavigate } from "react-router-dom";
import ArtistCard from "../../components/ArtistCard/ArtistCard";
import { useModal } from "../../context/ModalContext"; // polku riippuu projektirakenteesta


// Yksinkertainen hakukenttäkomponentti
const SearchInput = ({ placeholder, value, onChange, inputClass = "" }) => (
  <div className="relative w-full">
    <FaSearch className="absolute top-1/2 transform -translate-y-1/2 left-3 text-gray-400" />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`w-full pl-10 pr-4 py-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1 shadow-sm ${inputClass}`}
    />
  </div>
);

SearchInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputClass: PropTypes.string,
};

const BandList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bandRefs = useRef(new Map());
  // Tilat
  const [bands, setBands] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const { setIsModalOpen } = useModal();
  const [videoReady, setVideoReady] = useState(false);

  // const [ setShowInfo] = useState(false);
  const [availableArtistTypes, setAvailableArtistTypes] = useState([]);
  const [selectedArtistTypes, setSelectedArtistTypes] = useState([]);
  const [availableRegions, setAvailableRegions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [isGenreAccordionOpen, setIsGenreAccordionOpen] = useState(false);

  const [selectedDate, setSelectedDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );

  const handleModalSubmit = () => {
    if (!regionFilter) {
      toast.error("Valitse tai kirjoita maakunta!");
      return;
    }
  
    setShowModal(false);
    sessionStorage.setItem("hasVisited", "true");
    sessionStorage.setItem("hasSeenModalText", "true");
    sessionStorage.setItem("isModalOpen", "false"); // ✅ Tämä on tärkeä
    setShowModalText(true);
  
    // 🔔 Ilmoitetaan Navbarille että se voi nyt ilmestyä näkyviin
    window.dispatchEvent(new Event("navbarCheck"));
  };
  
  // Kaikki mahdolliset genret, jotka haetaan API:sta (checkbox-listaa varten)
  const [availableGenres, setAvailableGenres] = useState([]);
  // Checkbox-valintojen tallennus taulukkona
  const [selectedGenres, setSelectedGenres] = useState([]);

  // Näytetäänkö koko genrelista vai vain osa
  const [showAllGenres, setShowAllGenres] = useState(false);
  const [showAllRegions, setShowAllRegions] = useState(false);

  // Mobiilissa toggle joka näyttää/piilottaa "Alueet"-listan (Accordion)
  const [isMobileAccordionOpen, setIsMobileAccordionOpen] = useState(false);

  // Modalin tilat
  const [showModalText, setShowModalText] = useState(
    () => sessionStorage.getItem("hasSeenModalText") === "true"
  );
  const [showModal, setShowModal] = useState(
    () => (sessionStorage.getItem("hasVisited") ? false : true)
  );
  const [modalStep, setModalStep] = useState(1);

  // AOS ja sessionStorage-check
  useEffect(() => {
    const navEntries = performance.getEntriesByType("navigation");
    if (navEntries.length > 0 && navEntries[0].type === "reload") {
      sessionStorage.removeItem("hasVisited");
      sessionStorage.removeItem("hasSeenModalText");
    }
  }, []);

  useEffect(() => {
    const fetchArtistTypes = async () => {
      try {
        const response = await fetch("https://spiderlegsproductions.com/api/get_artist_types.php");
        const data = await response.json();
        if (data.success) {
          setAvailableArtistTypes(data.artist_types);
        }
      } catch (error) {
        console.error("Esiintyjätyyppien haku epäonnistui:", error);
      }
    };
    fetchArtistTypes();
  }, []);

  useEffect(() => {
    const fetchPerformanceRegions = async () => {
      try {
        const response = await fetch('https://spiderlegsproductions.com/api/get_performance_regions.php');
        const data = await response.json();
        if (data.success) {
          setAvailableRegions(data.performance_regions);
        }
      } catch (error) {
        console.error('Alueiden haku epäonnistui:', error);
      }
    };
    fetchPerformanceRegions();
  }, []);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        const response = await fetch(
          "https://spiderlegsproductions.com/api/get_genres.php"
        );
        const data = await response.json();
        if (data.success) {
          setAvailableGenres(data.genres);
        }
      } catch (error) {
        console.error("Genrejen haku epäonnistui:", error);
      }
    };
    fetchGenres();
  }, []);

  useEffect(() => {
    if (location.state?.openModal === true) {
      setShowModal(true);
      sessionStorage.setItem("hasVisited", "false");
      sessionStorage.setItem("hasSeenModalText", "false");
      setIsModalOpen(true);
    } else {
      setShowModal(false);
    }
  }, [location, setIsModalOpen]);
  

  useEffect(() => {
    if (location.state && location.state.skipModal) {
      setShowModal(false);
      sessionStorage.setItem("hasVisited", "true");
      sessionStorage.setItem("hasSeenModalText", "false");
      setShowModalText(false);
    } else if (!sessionStorage.getItem("hasVisited")) {
      setShowModal(true);
    }
  }, [location]);

  useEffect(() => {
    if (!showModal && selectedDate && typeFilter && regionFilter) {
      setSelectedArtistTypes([typeFilter]);
      setSelectedRegions([regionFilter]);
    }
  }, [showModal, selectedDate, typeFilter, regionFilter]);
  
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  // Haku: jos päivämäärää ei ole valittu, haetaan kaikki bändit; muulloin haetaan vapaana olevat
  useEffect(() => {
    if (!selectedDate) {
      axios
        .get("https://spiderlegsproductions.com/api/get_bands.php")
        .then((res) => {
          if (res.data.success) {
            setBands(res.data.bands || []);
          } else {
            console.error("Virhe get_bands:", res.data.error);
          }
        })
        .catch((err) => console.error("Virhe get_bands:", err));
    } else {
      axios
        .get("https://spiderlegsproductions.com/api/get_free_bands.php", {
          params: { date: selectedDate },
        })
        .then((res) => {
          if (res.data.success) {
            setBands(res.data.bands || []);
          } else {
            console.error("Virhe get_free_bands:", res.data.error);
          }
        })
        .catch((err) => console.error("Virhe get_free_bands:", err));
    }
  }, [selectedDate]);

  // Modalin toiminnot
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleNext = () => {
    if (modalStep === 1) {
      if (!selectedDate) {
        toast.error("Valitse tapahtuman päivämäärä!", { autoClose: 5000 });
        return;
      }
      setModalStep(2);
    } else if (modalStep === 2) {
      if (!typeFilter) {
        toast.error("Valitse esiintyjän tyyppi!", { autoClose: 5000 });
        return;
      }
      setModalStep(3);
    }
  };

  const handleBack = () => {
    if (modalStep > 1) {
      setModalStep(modalStep - 1);
    }
  };

  

  // Kun käyttäjä klikkaa jotakin genreruutua, togglataan se valituksi / pois valituista
  const toggleGenre = (genre) => {
    setSelectedGenres((prev) =>
      prev.includes(genre)
        ? prev.filter((g) => g !== genre)
        : [...prev, genre]
    );
  };

  const toggleArtistType = (type) => {
    setSelectedArtistTypes((prev) =>
      prev.includes(type)
        ? prev.filter((t) => t !== type)
        : [...prev, type]
    );
  };

  const toggleRegion = (region) => {
    setSelectedRegions((prev) =>
      prev.includes(region)
        ? prev.filter((r) => r !== region)
        : [...prev, region]
    );
  };

  // Filtteröinti
  const filteredBands = bands.filter((band) => {
    const matchName =
      searchTerm === "" ||
      band.name?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchLocation =
      locationFilter === "" ||
      band.location?.toLowerCase().includes(locationFilter.toLowerCase());

    // Bändin performance_regions vs. valitut regions
    const matchRegion =
      selectedRegions.length === 0 ||
      selectedRegions.some((selectedRegion) =>
        band.performance_regions?.toLowerCase().includes(selectedRegion.toLowerCase())
      );

    // Bändin artist_type vs. valitut artistTypes
    const matchType =
      selectedArtistTypes.length === 0 ||
      selectedArtistTypes.includes(band.artist_type);

    // Genrejen suodatus
    const bandGenreLower = band.genre?.toLowerCase() || "";
    const matchCheckboxGenres =
      selectedGenres.length === 0 ||
      selectedGenres.some((selected) =>
        bandGenreLower.includes(selected.toLowerCase())
      );

    const matchGenre = matchCheckboxGenres;

    return matchName && matchLocation && matchRegion && matchType && matchGenre;
      });

      // Jos modal on auki, näytetään se (päättömänä returnina suoraan)
 // Jos modal on auki, näytetään se (päättömänä returnina suoraan)
if (showModal) {
  return (
    <>
      <div className="fixed inset-0 z-40 flex items-center justify-center px-4">

        {/* Video taustalle kun valmis */}
        <video
  autoPlay
  loop
  muted
  className="absolute inset-0 w-full h-full object-cover"
  onLoadedData={() => setVideoReady(true)}
>
  <source src={modalVideo} type="video/mp4" />
  Your browser does not support the video tag.
</video>

{/* Näytetään varaelementti vain jos video ei ole vielä valmis */}
{!videoReady && (
  <div className="absolute inset-0 bg-black opacity-100 flex items-center justify-center z-20">
    <p className="text-darkest dark:text-primary dark:text-shadow-lg text-2xl font-customFont1">Ladataan...</p>
  </div>
)}


        {/* Tummennuskerros (näkyy myös kun video ei vielä valmis) */}
        <div className="absolute inset-0 bg-black bg-opacity-20" />

        {/* Modalin varsinainen sisältö */}
        <div className="relative z-10 bg-primary dark:bg-violet p-6 shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-xl mt-12 sm:mt-16 md:mt-0" data-aos="fade-in">

            

            {modalStep === 1 && (
              <div>
                <h2 className="text-4xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
                  Hei ja tervetuloa!
                </h2>
                <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
                  Löydetään yhdessä täydellinen esiintyjä tapahtumaasi!
                  Aloitetaan valitsemalla ensin tapahtumasi ajankohta.
                </p>
                <div className="relative mb-4">
                  <label
                    htmlFor="modaltDate"
                    className="block font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mb-2"
                  >
                    Valitse päivämäärä:
                  </label>
                  <input
                    id="modaltDate"
                    type="date"
                    value={selectedDate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={handleDateChange}
                    className="w-full h-12 font-customFont1 bg-white dark:bg-darkest dark:text-primary border border-gray-800 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-primary transition text-center appearance-none px-4"
                  />


                </div>

                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 w-full text-center">
                <ResponsiveButton
                    onClick={() => navigate("/")}
                    variant="modalbutton"
                  >
                    Poistu
                  </ResponsiveButton>

                  <ResponsiveButton
                    onClick={handleNext}
                    variant="modalbutton"
                  >
                    Seuraava
                  </ResponsiveButton>
                </div>

                <div className="relative mt-6">
                  <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light flex justify-center">
                    {/* <button
                      onClick={() => setShowInfo(true)}
                      className="text-darkest dark:text-primary hover:underline flex items-center"
                    >
                      🎤 Tartu tilaisuuteen ja liity mukaan!{" "}
                      <FaInfoCircle className="inline text-xl ml-2 cursor-pointer" />
                    </button> */}
                  </p>
                  {/* {showInfo && (
                    <>
                      <div
                        className="fixed inset-0 bg-black bg-opacity-75 z-40"
                        onClick={() => setShowInfo(false)}
                        onKeyDown={(e) => e.key === "Enter" && setShowInfo(false)}
                        role="button"
                        tabIndex="0"
                      />
                      <div
                        className="fixed inset-0 z-50 overflow-y-auto px-4 py-8 sm:py-20 flex justify-center items-start"
                        data-aos="fade-in"
>


                        <div
                          className="relative z-10 bg-primary dark:bg-violet p-6 shadow-lg w-[90vw] max-w-2xl max-h-[80vh] overflow-y-auto"

                          data-aos="fade-in"
                        >

                          <p className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
                            Liity verkostoomme!
                          </p>
                          
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light my-4">
                            Etsimme jatkuvasti bändejä, trubaduureja, DJ:itä, tapahtumatekniikan ammattilaisia ja muita esiintyjiä,
                            jotka haluavat enemmän näkyvyyttä, lisää keikkoja ja uusia mahdollisuuksia!
                          </p>
                          
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light my-4">
                            Oletko valmis viemään esiintymisesi seuraavalle tasolle ja tavoittamaan laajemman yleisön?
                            Spiderlegs Productions yhdistää tapahtumajärjestäjät ja esiintyjät, jotta keikat löytyvät helpommin
                            ja tapahtumat onnistuvat saumattomasti.
                          </p>

                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light my-4">
                            Tällä sivustolla tarjoamme <strong>passiivista myyntiä</strong> – emme toimi ohjelmatoimistona emmekä myy keikkoja,
                            vaan tarjoamme esiintyjille ja yhteistyökumppaneille laadukkaan näkyvyyspaikan. Asiakkaat voivat ottaa yhteyttä suoraan
                            esiintyjän omaan profiiliin ja tehdä varauksen ilman välikäsiä. Me puolestamme huolehdimme koko sivuston
                            markkinoinnista, jotta juuri sinun profiilisi tavoittaa oikean yleisön.
                          </p>

                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light my-4">
                            ✅ Saat enemmän keikkoja ja esiintymismahdollisuuksia<br />
                            ✅ Tavoitat oikeat asiakkaat ilman turhaa säätöä<br />
                            ✅ Pääset osaksi laadukasta esiintyjäverkostoa
                          </p>
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold">
                            Haluatko mukaan?
                          </p>
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light my-4">
                            Ota yhteyttä, niin sovitaan lyhyt Teams-tapaaminen,
                            jossa kerromme lisää toiminnastamme ja siitä, kuinka
                            sinä voit hyötyä yhteistyöstä.
                          </p>
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mt-2">
                            Yhteystiedot:
                          </p>
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
                            📧 {" "}
                            <a
                              href="mailto:info@spiderlegsproductions.com"
                              className="text-linkcol hover:underline"
                            >
                              info@spiderlegsproductions.com
                            </a>
                          </p>
                          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
                            📞 {" "}
                            <a
                              href="tel:+358443519265"
                              className="text-linkcol hover:underline"
                            >
                              +358 44 351 92 65
                            </a>
                          </p>
                          <div className="flex justify-center px-4">
                            <ResponsiveButton
                              onClick={() => setShowInfo(false)}
                              className="my-4 w-full"
                            >
                              Sulje
                            </ResponsiveButton>
                          </div>
                        </div>
                      </div>
                    </>
                  )} */}
                </div>
              </div>
            )}
            {modalStep === 2 && (
              <div data-aos="fade-in">
                <h2 className="text-4xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
                  Valitaan esiintyjän tyyppi
                </h2>
                <p className="font-customFont1 dark:text-shadow-xl text-left text-darkest dark:text-primary text-xl font-light mb-4">
                  Mahtavaa! Nyt on aika valita esiintyjä tapahtumaasi. Kaipaatko
                  bändiä, joka nostattaa tunnelman ja saa yleisön tanssimaan, vai
                  trubaduuria, joka luo rennon ja intiimin ilmapiirin?
                </p>
                <div className="relative mb-4">
                  <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    className="w-full h-10 font-customFont1 bg-white dark:bg-darkest dark:text-primary border border-gray-800 rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 focus:ring-primary transition pr-4"
                  >
                    <option value="Kaikki">Valitse..</option>
                    <option value="Bändi">Bändi</option>
                    <option value="Trubaduuri">Trubaduuri</option>
                  </select>
                </div>
                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 w-full text-center mt-4">
                {modalStep > 1 && (
                  <ResponsiveButton
                    onClick={handleBack}
                    variant="modalbutton"
                  >
                    Edellinen
                  </ResponsiveButton>

                )}
                <ResponsiveButton
                  onClick={handleNext}
                  variant="modalbutton"
                >
                  Seuraava
                </ResponsiveButton>
              </div>



              </div>
            )}
            {modalStep === 3 && (
              <div data-aos="fade-in">
                <h2 className="text-4xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
                  Valitse tai kirjoita maakunta
                </h2>
                <p className="font-customFont1 dark:text-shadow-xl text-left text-darkest dark:text-primary text-xl font-light mb-4">
                  Hienoa! Missä tapahtuma järjestetään? Voit valita maakunnan
                  listasta tai kirjoittaa sen itse.
                </p>
                <div className="relative mb-4">
                  <label
                    htmlFor="regionInput"
                    className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold"
                  >
                    Maakunta:
                  </label>
                  <input
                    id="regionInput"
                    list="regionOptions"
                    value={regionFilter}
                    onChange={(e) => setRegionFilter(e.target.value)}
                    className="w-full font-customFont1 bg-white dark:bg-darkest dark:text-primary border border-gray-800 rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 focus:ring-primary transition pr-4 h-10 mt-2"
                    placeholder="Valitse tai kirjoita maakunta.."
                  />
                 <datalist id="regionOptions">
                  <option value="Ahvenanmaa" />
                  <option value="Uusimaa" />
                  <option value="Varsinais-Suomi" />
                  <option value="Satakunta" />
                  <option value="Kanta-Häme" />
                  <option value="Pirkanmaa" />
                  <option value="Päijät-Häme" />
                  <option value="Kymenlaakso" />
                  <option value="Etelä-Karjala" />
                  <option value="Etelä-Savo" />
                  <option value="Pohjois-Savo" />
                  <option value="Pohjois-Karjala" />
                  <option value="Keski-Suomi" />
                  <option value="Etelä-Pohjanmaa" />
                  <option value="Pohjanmaa" />
                  <option value="Keski-Pohjanmaa" />
                  <option value="Pohjois-Pohjanmaa" />
                  <option value="Kainuu" />
                  <option value="Lappi" />
                </datalist>
                </div>
                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 w-full text-center mt-4">
                <ResponsiveButton
                  onClick={handleBack}
                  variant="modalbutton"
                >
                  Edellinen
                </ResponsiveButton>
                <ResponsiveButton
                  onClick={handleModalSubmit}
                  variant="modalbutton"
                >
                  Hae esiintyjä
                </ResponsiveButton>

                </div>

              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  // Määritellään sisällön osiot erikseen, jotta niitä voidaan renderöidä
  // eri tavalla responsiivisuuden mukaan

  // Teksti (ohjeet) -osio
  const textSection = (
    <div data-aos="fade-left">
      <div className="">
        {showModalText ? (
          <>
            <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
              Siirrytään hakutuloksiin!
            </h3>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary font-light xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
              Nyt kun olet määritellyt tapahtuman
              päivämäärän, esiintyjätyypin ja sijainnin, voimme näyttää sinulle
              kyseisenä päivänä vapaana olevat esiintyjät. Tarvittaessa voit
              käynnistää esiintyjäkartoituksen uudelleen etusivun kautta.
            </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary font-bold my-2 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
             
              Voit nyt suodatella esiintyjiä vapaasti.
            </p>
            <div>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">
                  Hae vapaata esiintyjää päivämäärän mukaan:
                </span>{" "}
                <span>Valitse sopiva ajankohta.</span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Esiintyjätyyppi:</span>{" "}
                <span>
                  Valitse esiintyjän tyypin mukaan.
                </span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Genre:</span>{" "}
                <span>Hae musiikkityylin mukaan.</span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Esiintymisalue:</span>{" "}
                <span>
                  Alue, jonka esiintyjä on määrittänyt keikka-alueekseen.
                </span>
              </p>
             
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Kotipaikka:</span>{" "}
                <span>Hae esiintyjää sen kotipaikkakunnan perusteella.</span>
              </p>

              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Nimi:</span>{" "}
                <span>Kirjoita esiintyjän nimi tai sen osa.</span>
              </p>
              
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg my-4">
                <span className="font-bold">
                  Kun löydät sopivan tai kiinnostavan esiintyjän, voit vierailla
                  tämän profiilisivulla, lähettää viestin, jättää palautetta tai
                  pyytää tarjousta, jonka saat hetkessä sähköpostiisi, helppoa!
                </span>
              </p>
            </div>
          </>
        ) : (
          <>
            <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
              Hienoa nähdä sinut jälleen täällä!
            </h3>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
              Voit suodatella esiintyjiä hakukenttien avulla:
              <br />
              <br />
            </p>
            <div>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">
                  Hae vapaata esiintyjää päivämäärän mukaan:
                </span>{" "}
                <span>Valitse sopiva ajankohta.</span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Esiintyjätyyppi:</span>{" "}
                <span>
                  Valitse esiintyjän tyypin mukaan.
                </span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Genre:</span>{" "}
                <span>Hae musiikkityylin mukaan.</span>
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Esiintymisalue:</span>{" "}
                <span>
                  Alue, jonka esiintyjä on määrittänyt keikka-alueekseen.
                </span>
              </p>
             
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Kotipaikka:</span>{" "}
                <span>Hae esiintyjää sen kotipaikkakunnan perusteella.</span>
              </p>

              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-bold">Nimi:</span>{" "}
                <span>Kirjoita esiintyjän nimi tai sen osa.</span>
              </p>
              
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary my-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                <span className="font-normal">
                  Kun löydät sopivan tai kiinnostavan esiintyjän, voit vierailla
                  tämän profiilisivulla, lähettää viestin, jättää palautetta tai
                  pyytää tarjousta, jonka saat hetkessä sähköpostiisi, helppoa!
                </span>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );

  // Suodattimet -osio
const filtersSection = (
  <div data-aos="fade-right">
    <div className="space-y-4">
      {/* Hakukentät */}
      <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight">
        Suodattimet
      </h3>

        {/* Päivämäärä */}
        <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.6 }}
        className="relative"
      >
        <FaSearch className="absolute top-1/2 transform -translate-y-1/2 left-3 text-gray-400 pointer-events-none" />
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          min={new Date().toISOString().split("T")[0]}
          className="w-full font-customFont1 bg-white dark:bg-darkest text-gray-400 dark:text-gray-400 border border-gray-800 rounded-xl shadow-sm focus:outline-none text-left pl-10 pr-4 py-2 focus:ring-2 focus:ring-primary transition xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg"
          style={{ height: "41px", WebkitAppearance: "none", MozAppearance: "none" }}
        />
      </motion.div>

        {/* Esiintyjätyypit */}
        {availableArtistTypes.length > 0 && (
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary font-bold mb-2 pl-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
            Esiintyjätyyppi:
          </p>
          <div className="grid grid-cols-2 gap-2 pl-4">
            {availableArtistTypes.map((type, idx) => (
              <label key={idx} className="inline-flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedArtistTypes.includes(type)}
                  onChange={() => toggleArtistType(type)}
                  className="form-checkbox rounded text-primary focus:ring-primary"
                />
                <span className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary font-light xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                  {type}
                </span>
              </label>
            ))}
          </div>
        </motion.div>
      )}

        {/* Genret mobiilissa (accordion) */}
        {availableGenres.length > 0 && (
        <div className="lg:hidden">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.45 }}
          >
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary font-bold mb-2 pl-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
              Suodata genreittäin:
            </p>
            <button
              className="ml-4 mb-2 text-darkest dark-text-shadow-lg dark:text-primary underline xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg dark:text-shadow-lg font-customFont1"
              onClick={() => setIsGenreAccordionOpen(!isGenreAccordionOpen)}
            >
              {isGenreAccordionOpen ? "Piilota genret" : "Näytä genret"}
            </button>

            {isGenreAccordionOpen && (
              <div>
                <div className="grid grid-cols-2 gap-2 pl-4">
                  {(showAllGenres ? availableGenres : availableGenres.slice(0, 10)).map((genre, idx) => (
                    <label key={idx} className="inline-flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={selectedGenres.includes(genre)}
                        onChange={() => toggleGenre(genre)}
                        className="form-checkbox rounded text-primary focus:ring-primary"
                      />
                      <span className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                        {genre}
                      </span>
                    </label>
                  ))}
                </div>
                {availableGenres.length > 10 && (
                  <button
                    onClick={() => setShowAllGenres(!showAllGenres)}
                    className="mt-2 font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary font-light underline pl-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg"
                  >
                    {showAllGenres ? "Näytä vähemmän" : "Näytä lisää genrejä"}
                  </button>
                )}
              </div>
            )}
          </motion.div>
        </div>
      )}
      {/* Genret desktopissa */}
      {availableGenres.length > 0 && (
        <div className="hidden lg:block">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.45 }}
          >
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mb-2 pl-4">
              Genret:
            </p>
            <div className="grid grid-cols-2 gap-2 pl-4">
              {(showAllGenres ? availableGenres : availableGenres.slice(0, 10)).map((genre, idx) => (
                <label key={idx} className="inline-flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedGenres.includes(genre)}
                    onChange={() => toggleGenre(genre)}
                    className="form-checkbox rounded text-primary focus:ring-primary"
                  />
                  <span className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary text-lg font-light">
                    {genre}
                  </span>
                </label>
              ))}
            </div>
            {availableGenres.length > 10 && (
              <button
                onClick={() => setShowAllGenres(!showAllGenres)}
                className="mt-2 font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary text-lg font-light underline pl-4"
              >
                {showAllGenres ? "Näytä vähemmän" : "Näytä lisää genrejä"}
              </button>
            )}
          </motion.div>
        </div>
      )}

      {/* Alueet mobiilissa (accordion) */}
      {availableRegions?.length > 0 && (
        <div className="lg:hidden">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.48 }}
          >
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary font-bold mb-2 pl-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
              Suodata alueen mukaan:
            </p>
            <button
              className="ml-4 mb-2 text-darkest dark:text-primary underline xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg dark:text-shadow-lg font-customFont1"
              onClick={() => setIsMobileAccordionOpen(!isMobileAccordionOpen)}
            >
              {isMobileAccordionOpen ? "Piilota alueet" : "Näytä alueet"}
            </button>
            {isMobileAccordionOpen && (
              <div>
                <div className="grid grid-cols-2 gap-2 pl-4">
                  {(showAllRegions ? availableRegions : availableRegions.slice(0, 10)).map(
                    (region, idx) => (
                      <label
                        key={idx}
                        className="inline-flex items-center space-x-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={selectedRegions.includes(region)}
                          onChange={() => toggleRegion(region)}
                          className="form-checkbox rounded text-primary focus:ring-primary"
                        />
                        <span className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary font-light xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                          {region}
                        </span>
                      </label>
                    )
                  )}
                </div>
                {availableRegions.length > 10 && (
                  <button
                    onClick={() => setShowAllRegions(!showAllRegions)}
                    className="mt-2 font-customFont1 dark:text-shadow-lg text-darkest dark:text-primaryfont-light underline pl-4 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg"
                  >
                    {showAllRegions ? "Näytä vähemmän" : "Näytä lisää alueita"}
                  </button>
                )}
              </div>
            )}
          </motion.div>
        </div>
      )}

      {/* Alueet desktopissa */}
      {availableRegions?.length > 0 && (
        <div className="hidden lg:block">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.48 }}
          >
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mb-2 pl-4">
              Alueet:
            </p>
            <div className="grid grid-cols-2 gap-2 pl-4">
              {(showAllRegions ? availableRegions : availableRegions.slice(0, 10)).map(
                (region, idx) => (
                  <label
                    key={idx}
                    className="inline-flex items-center space-x-2 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={selectedRegions.includes(region)}
                      onChange={() => toggleRegion(region)}
                      className="form-checkbox rounded text-primary focus:ring-primary"
                    />
                    <span className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary text-lg font-light">
                      {region}
                    </span>
                  </label>
                )
              )}
            </div>
            {availableRegions.length > 10 && (
              <button
                onClick={() => setShowAllRegions(!showAllRegions)}
                className="mt-2 font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary text-lg font-light underline pl-4"
              >
                {showAllRegions ? "Näytä vähemmän" : "Näytä lisää alueita"}
              </button>
            )}
          </motion.div>
        </div>
      )}

      {[
        {
          placeholder: "Kotipaikka...",
          value: locationFilter,
          onChange: setLocationFilter,
          delay: 0.2,
        },
        {
          placeholder: "Etsi esiintyjää nimellä...",
          value: searchTerm,
          onChange: setSearchTerm,
          delay: 0.1,
        },
       
      ].map(({ placeholder, value, onChange, delay }, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay }}
          className="relative"
        >
          <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full font-customFont1 bg-white dark:bg-darkest text-gray-400 dark:text-gray-400 border border-gray-800 rounded-xl shadow-sm focus:outline-none text-left pl-10 pr-4 py-2 focus:ring-2 focus:ring-primary transition xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg"
            style={{ height: "41px" }}
          />
        </motion.div>
      ))}

    </div>
  </div>
);

filteredBands.forEach((band) => {
  if (!bandRefs.current.has(band.id)) {
    bandRefs.current.set(band.id, React.createRef());
  }
});

// Esiintyjäkortit -osio
const cardsSection = (
  <div data-aos="fade-left">
    <div className="grid grid-cols-2 xxxsm:grid-cols-1 xxsm:grid-cols-1 xsm:grid-cols-2 sm:grid-cols-2 mdd:grid-cols-3 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4 ">
      <TransitionGroup component={null}>
        {filteredBands.length > 0 ? (
          filteredBands.map((band) => {
            // Hanki olemassa oleva ref tai luo uusi
            if (!bandRefs.current.has(band.id)) {
              bandRefs.current.set(band.id, React.createRef());
            }
            const nodeRef = bandRefs.current.get(band.id);

            return (
              <CSSTransition
                key={band.id}
                timeout={300}
                classNames="band"
                nodeRef={nodeRef}
              >
                <div ref={nodeRef}>
                  <ArtistCard
                    band={{
                      ...band,
                      average_rating: Number(band.average_rating),
                    }}
                    variant="default"
                    onViewProfile={(slug) => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      navigate(`/esiintyja/${slug}`);
                    }}
                  />
                </div>
              </CSSTransition>
            );
          })
        ) : (
          // Luo nodeRef yksittäiselle "Ei esiintyjiä" -viestille
          <CSSTransition
            timeout={300}
            classNames="band"
            nodeRef={bandRefs.current.get("empty") || bandRefs.current.set("empty", React.createRef()).get("empty")}
          >
            <p
              ref={bandRefs.current.get("empty")}
              className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary text-1xl font-bold"
              data-aos="fade-up"
            >
              Ei esiintyjiä näillä hakuehdoilla.
            </p>
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  </div>
);




  return (
    <>
      <Helmet>
  <title>Bändit ja esiintyjät | Spiderlegs Productions</title>
  <meta
    name="description"
    content="Etsi täydellinen esiintyjä häihin, yritysjuhliin tai pikkujouluihin. Spiderlegs Productions tarjoaa äänentoiston, esitystekniikan sekä laajan valikoiman bändejä ja artisteja."
  />
  <meta
    name="keywords"
    content="bändi, artisti, keikka, häät, yritysjuhlat, pikkujoulut, keikkavälitys, esiintyjät"
  />

  {/* Open Graph - meta-tiedot */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Bändit ja esiintyjät | Spiderlegs Productions" />
  <meta property="og:description" content="Spiderlegs Productions - löydä sopiva esiintyjä tapahtumaasi ja pyydä helposti tarjousta." />
  <meta property="og:url" content="https://spiderlegsproductions.com/esiintyjat" />
  <meta property="og:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />

  {/* Twitter Card - meta-tiedot */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Bändit ja esiintyjät | Spiderlegs Productions" />
  <meta name="twitter:description" content="Spiderlegs Productions - löydä sopiva esiintyjä tapahtumaasi ja pyydä helposti tarjousta." />
  <meta name="twitter:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://spiderlegsproductions.com/esiintyjat" />
</Helmet>


      <HeaderWithAdd />

      <div className="relative min-h-screen w-full pb-10">

     {/* SIVUN SISÄLTÖ - Responsiivinen asettelu */}
        <div className="relative z-10 max-w-7xl mx-auto p-4 bg-primary dark:bg-violet bg-opacity-75 dark:bg-opacity-75 shadow-md">
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {/* Teksti tulee ensin mobiilissa, oikealle desktopissa */}
            <div className="order-1 lg:order-2 lg:col-span-2" data-aos="fade-left">
              {textSection}
            </div>

            {/* Suodattimet toisena mobiilissa, vasemmalle desktopissa */}
            <div className="order-2 lg:order-1" data-aos="fade-right">
              {filtersSection}
            </div>

            {/* Kortit viimeisenä mobiilissa, oikealle desktopissa */}
            <div className="order-3 lg:order-2 lg:col-span-2" data-aos="fade-left">
              {cardsSection}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BandList;
